import React, { useEffect } from "react";
import { Header } from "../Layout/Header.jsx";
import { ObavijestiCasino } from "../Layout/ObavijestiCasino.jsx";
import { MetaTags } from "../Layout/MetaTags.jsx";
import { AccountTabletLinkovi } from "../../Components/Account/AccountTabletLinkovi.jsx";
import { RestrictedAccess } from "../../Components/Layout/RestrictedAccess.jsx";

export default function AccountSuperSpin(props) { 

    useEffect(() => {
        if (document.getElementById("superspin")) {
           (function (d, id) {
               let js, fjs = d.getElementsByTagName('script')[0];
               if (d.getElementById(id)) {
                   superSpinApp.init("superspin", "mobile");
                   return;
               }
               js = d.createElement('script'); js.id = id;
               js.async = true;
               js.onload = function () {
                   superSpinApp.init("superspin", "mobile");
               };
               js.src = "https://www.supersport.hr/gamification/assets/superspin-ui/latest/s2/main.js?t=" + casino.utils.generateMinuteTimestamp(10);
               fjs.parentNode.insertBefore(js, fjs);

                // let js, fjs = d.getElementsByTagName('script')[0];
                // if (d.getElementById(id)) {
                //     return;
                // }
                // js = d.createElement('script');
                // js.id = id;
                // js.async = true;
                // js.onload = function () {
                //     superSpinApp.init("superspin", "mobile");
                // };
                // js.src = "https://www.supersport.hr/gamification/assets/superspin-ui/latest/s2/main.js?t=" + casino.utils.generateMinuteTimestamp(10);
                // fjs.parentNode.insertBefore(js, fjs);
           }(document, 'superspin-ui'));
        }

        const cssId = 'superSpinCss';
        if (!document.getElementById(cssId)) {
           const head = document.getElementsByTagName('head')[0];
           const link = document.createElement('link');
           link.id = cssId;
           link.rel = 'stylesheet';
           link.type = 'text/css';
           link.href = 'https://www.supersport.hr/gamification/assets/superspin-ui/latest/s2/mobile.css?t=' + casino.utils.generateMinuteTimestamp(10);;
           link.media = 'all';
           head.appendChild(link);
        }
    }, [props.user]);
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.route.location.pathname]);

    if (props.user)
        return (
            <>
                <MetaTags title="SuperSpin | SuperCasino" description="SuperSpin | SuperCasino | Postani dio Ekskluzivnog Casino Kluba | SuperCasino" />
                <Header key="header" {...props} />
                <div className="flex margin-1p-on-tablet">
                    <AccountTabletLinkovi {...props} />
                    <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding account-obavijesti-page" style={{ minHeight: 400, zIndex:999 }}>
                        <div id="superspin" className="superspin"></div>
                    </div>
                </div>
                <ObavijestiCasino {...props} />
            </>
        )

    else
        return (
            <>
                <Header key="header"  {...props} />
                <RestrictedAccess {...props} />
            </>
        )
}
